<template>
  <el-dialog
    title="新增"
    v-model="isShow"
    width="420px"
    :before-close="handleClose"
  >
    <el-form
      ref="rateForm"
      :inline="true"
      :model="rateInfo"
      size="mini"
      :rules="rateRules"
      ><div class="row">
        <el-form-item label="应用" prop="appId" label-width="120px">
          <el-select filterable v-model="rateInfo.appId" clearable size="mini">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in appList"
              :key="index"
            />
          </el-select>
        </el-form-item>
      </div>
      <!-- <div class="row">
        <el-form-item label="版本号" prop="versionCode" label-width="120px">
          <el-input v-model="rateInfo.versionCode" />
        </el-form-item>
      </div> -->
      <div class="row">
        <el-form-item label="版本序号" prop="versionName" label-width="120px">
          <el-input placeholder="eg:1.0.0" v-model="rateInfo.versionName" />
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="版本号" prop="versionCode" label-width="120px">
          <el-input placeholder="eg:10" v-model="rateInfo.versionCode" />
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="Release" prop="isRelease" label-width="120px">
          <el-select
            filterable
            v-model="rateInfo.isRelease"
            clearable
            size="mini"
          >
            <el-option
              :label="item"
              :value="index"
              v-for="(item, index) in isReleaseOpts"
              :key="index"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="升级时间" prop="upgradeDate" label-width="120px">
          <el-date-picker v-model="rateInfo.upgradeDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="版本说明" prop="releaseNote" label-width="120px">
          <el-input
            type="textarea"
            :rows="4"
            v-model.trim="rateInfo.releaseNote"
            size="mini"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>

    <el-upload
      class="upload-demo"
      drag
      action=""
      :auto-upload="false"
      :multiple="false"
      :on-change="doUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose" size="mini">{{
          $t("system.cancel")
        }}</el-button>
        <el-button type="primary" :loading="saving" @click="doCreateRate" size="mini">{{
          $t("system.confirm")
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import baseServer from "../source/basedata";
export default {
  props: ["isShowDialog"],
  emits: ["onDialogClose"],
  data() {
    return {
      rateInfo: {
        appId: null,
         versionCode: null,
        versionName: null,
        isRelease: 0,
        upgradeDate: null,
      },
      rateRules: {
        appId: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        //  versionCode: [
        //   {
        //     required: true,
        //     trigger: "blur",
        //    },
        //  ],
        versionName: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        upgradeDate: [
          {
            required: true,
            trigger: "blur",
          },
        ],
      },
      appList: [
        {
          id: 1,
          name: "CBS",
        },
        {
          id: 3,
          name: "PDA",
        },
          {
          id: 5,
          name: "New PDA",
        },
        {
          id: 6,
          name: "ICS PDA",
        },
      ],
      isReleaseOpts: ["否", "是"],
      // organizationList: [
      //   { id: 1, name: "壹站供应链管理有限公司" },
      //   { id: 2, name: "上海道骊物流有限公司" }
      // ]
      file: null,
      saving:false,
    };
  },
  computed: {
    organizationList() {
      return this.$store.state.constants.saleCompanys;
    },

    isShow() {
      return this.isShowDialog;
    },
  },
  methods: {
    doUpload(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      this.file = formData;
    },

    handleClose() {
      this.$emit("onDialogClose");
    },
    doCreateRate() {
      if (this.file == null) {
        this.$message.error("请选择文件");
        return;
      }

      this.$refs["rateForm"].validate((valid) => {
        if (valid) {
          this.saving = true;
          let params = {...this.rateInfo,upgradeDate:moment(this.rateInfo.upgradeDate).format("YYYY-MM-DD HH:mm:ss")}
          if(!params.versionCode || params.versionCode ==''){
            delete params.versionCode
          }
          let paramsStr = Object.keys(params).map(key=>`${key}=${params[key]}`).join('&')
          // console.log(paramsStr)

          baseServer.upgradeCbsClient(paramsStr, this.file).then(() => {
            this.saving = false;
            this.$message.success("上传成功");
            this.handleClose();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.el-form-item__label) {
    font-size: 12px;
  }
  :deep(.el-input--mini) {
    max-width: 180px;
  }
}
</style>
